import { SubtitleControl } from './SubtitleControl';
export default SubtitleControl;
